// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"e207a427","215":"0a20cff8","321":"57840f5d","323":"6a45a5bb","436":"c23e8f55","584":"a6d82acd","664":"9d8feea7","672":"afe2a4e0","850":"78b7961e","976":"edf61ffa","979":"2c774cdb"}[chunkId] + ".chunk.js";
};